import { render, staticRenderFns } from "./AppointmentReminderView.vue?vue&type=template&id=78c0b63e&scoped=true&"
import script from "./AppointmentReminderView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentReminderView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentReminderView.vue?vue&type=style&index=0&id=78c0b63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0b63e",
  null
  
)

export default component.exports